import { WON_STAGE } from "../domain/deals/stageModel";

export const prefersReducedMotion = (): boolean =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;

const COLORS = ["#F77119", "#FFAB75", "#1A1A1A", "#FFC9A3"];

/**
 * Celebration micro-animation: a won deal (spec 09 §2), a saved « Démo bookée », a lead sent to the pipeline
 * (« Envoyer dans le pipeline »). Only ever called after the save succeeded. No-op with prefers-reduced-motion. Returns a cleanup.
 */
export const launchConfetti = (
  root: HTMLElement = document.body,
  count = 24,
): (() => void) => {
  if (prefersReducedMotion()) return () => undefined;
  const layer = document.createElement("div");
  layer.setAttribute("aria-hidden", "true");
  layer.style.cssText =
    "position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:100";
  for (let i = 0; i < count; i++) {
    const piece = document.createElement("span");
    piece.style.cssText = `position:absolute;left:${(i * 37) % 100}%;top:-12px;width:8px;height:12px;border-radius:2px;background:${COLORS[i % COLORS.length]}`;
    piece.animate?.(
      [
        { transform: "translateY(0) rotate(0deg)", opacity: 1 },
        {
          transform: `translateY(${60 + (i % 5) * 8}vh) rotate(${i % 2 ? 540 : -540}deg)`,
          opacity: 0,
        },
      ],
      {
        duration: 1100 + (i % 4) * 120,
        easing: "cubic-bezier(0.16,1,0.3,1)",
        fill: "forwards",
      },
    );
    layer.appendChild(piece);
  }
  root.appendChild(layer);
  const timer = window.setTimeout(() => layer.remove(), 1700);
  return () => {
    window.clearTimeout(timer);
    layer.remove();
  };
};

/** GAVION celebrations (owner 2026-10-23): the call results that throw confetti once saved. */
export const celebratesOutcome = (outcome: string): boolean =>
  outcome === "demo_booked";

/** GAVION celebrations: a save that moves a deal into « Gagné » (a deal already won and edited again is no new win). */
export const isNewWin = (previousStage: unknown, stage: unknown): boolean =>
  stage === WON_STAGE && previousStage !== WON_STAGE;
